import * as React from "react";
export default (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 24 24"
  >
    <defs>
      <path
        id="icons-bug_svg__a"
        d="M16.455 17.365l-3.06 3.061a1.967 1.967 0 01-2.779-.001l-3.06-3.062L6 18.918V21H4v-2.08c0-.53.211-1.04.586-1.415l1.921-1.92a1.955 1.955 0 01-.002-.084V15h-2.5v-2h2.5v-.466L4.59 10.62a2 2 0 01-.586-1.414V7h2v2.205l.728.728a5.504 5.504 0 011.638-2.56l-.78-.78a2 2 0 01-.586-1.414V3h2v2.179l1.143 1.143A5.488 5.488 0 0112.005 6a5.49 5.49 0 011.857.321l1.143-1.141V3h2v2.18a2 2 0 01-.586 1.415l-.779.777a5.503 5.503 0 011.638 2.56l.727-.727V7h2v2.205a2 2 0 01-.586 1.414l-1.914 1.913V13h2.5v2h-2.5v.5c0 .028 0 .057-.002.085l1.92 1.919c.374.375.585.884.585 1.415v2.08h-2v-2.08l-1.553-1.554zm-.95-4.865h-2.5v5.487l2.5-2.501V12.5zm-4.5 0h-2.5v2.985l2.5 2.5V12.5zm1-4.5a3.503 3.503 0 00-3.355 2.5h6.71A3.502 3.502 0 0012.005 8z"
      />
    </defs>
    <use fill="currentColor" fillRule="evenodd" xlinkHref="#icons-bug_svg__a" />
  </svg>
);
